import styled, { css } from 'styled-components'
import { BaseButton } from '../../base'

export const DesktopWrapper = styled.div`
  display: none;

  @media (min-width: ${({ theme }) => theme.breakpoints?.tablet}px) {
    display: block;
  }
`

export const Wrapper = styled.div`
  position: relative;

  @media (min-width: ${({ theme }) => theme.breakpoints?.tablet}px) {
    display: none;
  }
`

export const MenuButton = styled(BaseButton)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 27px;
  height: 27px;
  flex-shrink: 0;
  border-radius: 8px;
  background-color: transparent;
`

export const Dropdown = styled.div<{ $open: boolean }>`
  position: absolute;
  top: calc(100% + 0.5rem);
  inset-inline-end: 0;
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: max(214px, 100%);
  padding: 24px 20px;
  border-radius: 24px;
  border: 1px solid white;
  background-color: rgba(254, 254, 254, 0.56);
  box-shadow: 0 0 34px rgba(0, 0, 0, 0.15);
  z-index: 100;
  backdrop-filter: blur(12px);
  ${({ $open, theme }) => css`
    visibility: ${$open ? 'visible' : 'hidden'};
    opacity: ${$open ? 1 : 0};
    transition:
      visibility 0.2s,
      opacity 0.2s,
      transform 0.2s;
    pointer-events: ${$open ? 'auto' : 'none'};
    transform: ${$open ? 'translateY(0)' : 'translateY(-10px)'};
    transform-origin: top ${theme.isRtl ? 'left' : 'right'};
  `};
`
